import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { apiRequest } from "../../utils/api";
import { useNavigate } from "react-router-dom";

function DynamicText() {
  const [areas, setAreas] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAreas();
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => <>{index + 1}</>,
    },
    {
      name: "Area",
      selector: (row) => (
        <>
          <p>{row?.area}</p>
        </>
      ),
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          <p>{row?.status}</p>
        </>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <button
            disabled={row?.file_status == "deleted"}
            onClick={() => navigateToArea(row.area)}
            className="btn btn-success"
          >
            Edit
          </button>{" "}
          &nbsp;
          <button
            disabled={row?.file_status == "deleted"}
            onClick={() => deleteRow(row)}
            className="btn btn-danger"
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  async function getAreas() {
    try {
      let res = await apiRequest.get(`/dynamic-text/all`);
      if (res.data.status == 200) {
        setAreas(res.data.message);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function deleteRow() {}

  function navigateToArea(area) {
    if (area == "new") {
      navigate("/dynamic-add/" + area);
    } else {
      navigate("/dynamic-edit/" + area);
    }
  }

  return (
    <>
      <div>
        <div className="main-content">
          <h2>Dynamic Areas</h2>
          <div className="row">
            <div className="col-md-12 mb-5">
              <button
                className="btn btn-success"
                onClick={() => navigateToArea("new")}
              >
                Add Area
              </button>
            </div>
            <div className="col-md-12 mb-5">
              <DataTable columns={columns} data={areas} pagination />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DynamicText;
